import { Injectable } from '@angular/core';
import { AppConstants } from '@app/core/constants/app.constants';
import { LOG_LEVEL, LogLevel } from '@app/shared/utils/log-level';

type LoggerAny = unknown;

const logValueMap: Record<LogLevel, number> = {
  NONE: 0,
  ERROR: 1,
  WARN: 2,
  INFO: 3,
  TRACE: 4
};

@Injectable({ providedIn: 'root' })
export class Logger {
  private _level: LogLevel = LOG_LEVEL.NONE;

  constructor() {
    this._level = AppConstants.logLevel;
  }

  private log(message: LoggerAny, level: LogLevel, params: LoggerAny[]) {
    if (this.shouldLog(level)) {
      switch (level) {
        case LOG_LEVEL.ERROR:
          console.error(message, ...params);
          break;
        case LOG_LEVEL.TRACE:
          console.log(message, ...params);
          break;
        case LOG_LEVEL.WARN:
          console.warn(message, ...params);
          break;
        case LOG_LEVEL.INFO:
          console.info(message, ...params);
          break;
        default:
          console.debug(message, ...params);
      }
    }
  }

  private shouldLog(level: LogLevel) {
    return logValueMap[this._level] >= logValueMap[level];
  }

  error(message: LoggerAny, ...optionalParams: LoggerAny[]) {
    this.log(message, LOG_LEVEL.ERROR, optionalParams);
  }

  warn(message: LoggerAny, ...optionalParams: LoggerAny[]) {
    this.log(message, LOG_LEVEL.WARN, optionalParams);
  }

  info(message: LoggerAny, ...optionalParams: LoggerAny[]) {
    this.log(message, LOG_LEVEL.INFO, optionalParams);
  }

  trace(message: LoggerAny, ...optionalParams: LoggerAny[]) {
    this.log(message, LOG_LEVEL.TRACE, optionalParams);
  }
}
